import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const PageTreeEmptyComponentLoader: LoadableType<{
	rootId: string | null;
	spaceKey: string;
	isPageTreeLoading: boolean;
	showFooterCreateButtons: boolean;
	onInitialLoadComplete: () => void;
	actions: {
		handleLoadingError: (error: Error) => void;
	};
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeEmptyComponent" */ './PageTreeEmptyComponent.tsx'
			)
		).PageTreeEmptyComponent,
});
